import * as React from 'react';
import cn from 'classnames';

import CloseButton from '../../../BaseComponents/Button/components/CloseButton/CloseButton';
import { useTheme } from '../../../theme';

interface Props {
	className?: string;
	onClick: () => void;
}

const BaggageDeleteButton: React.FC<Props> = ({ className, onClick }) => {
	const { BaggageDeleteButton: css } = useTheme('BaggageDeleteButton');

	return (
		<CloseButton
			classes={{ root: cn(css.root, className) }}
			onClick={onClick}
			variant="closePopup"
		/>
	);
};

export default BaggageDeleteButton;
